import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Slider from './Slider'
import { Trans } from 'react-i18next';
function SliderItem (props){
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };
    const menu = () =>{
            return(
                <MenuItem ><Slider nodes={props.nodes}/></MenuItem>
            )
    }


    return (
        <div>
        <MenuItem onClick={handleClick}><Trans>Trasparenza</Trans></MenuItem>
        <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
          {menu()}
      </Menu>
      </div>
        )
}

export default SliderItem;